const routeAdminUsers = () => '/admin-users';

export default routeAdminUsers;